var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-summary',{attrs:{"cells":_vm.cells}}),_c('report-graph',{attrs:{"chartData":_vm.chartData,"ratesSwitchLabel":_vm.ratesSwitchLabel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }